import React from "react";
function createLinkNode(font) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = font;
    return link;
}
const useFontLoader = ()=>{
    const [currentFontLinks, setCurrentFontLinks] = React.useState(new Set());
    const linksMapRef = React.useRef(new Map());
    React.useEffect(()=>{
        return ()=>{
            linksMapRef.current.forEach((link)=>{
                if (document.head.contains(link)) {
                    document.head.removeChild(link);
                }
            });
            linksMapRef.current.clear();
        };
    }, []);
    const setFontLinks = React.useCallback(async (newFonts)=>{
        const newFontLinksSet = new Set(newFonts);
        // Remove fonts that are no longer needed
        currentFontLinks.forEach((fontLink)=>{
            if (!newFontLinksSet.has(fontLink)) {
                const link = linksMapRef.current.get(fontLink);
                if (link && document.head.contains(link)) {
                    document.head.removeChild(link);
                    linksMapRef.current.delete(fontLink);
                }
            }
        });
        // Add new fonts and wait for them to load
        const loadPromises = [];
        newFontLinksSet.forEach((font)=>{
            if (!currentFontLinks.has(font)) {
                const link = createLinkNode(font);
                // One missing stylesheet must not cost the preview every other font.
                const loadPromise = new Promise((resolve)=>{
                    link.onload = ()=>resolve();
                    link.onerror = ()=>{
                        console.warn(`Failed to load font: ${font}`);
                        resolve();
                    };
                });
                loadPromises.push(loadPromise);
                document.head.appendChild(link);
                linksMapRef.current.set(font, link);
            }
        });
        await Promise.all(loadPromises);
        setCurrentFontLinks(newFontLinksSet);
    }, [
        currentFontLinks
    ]);
    return {
        setFontLinks
    };
};
export { useFontLoader };
